import { differenceInSeconds } from 'date-fns';

import { PLAN_INTERVAL, PLAN_CODE_INTERNVAL } from '../../constants';

export const calculateOrderCost = (currentDate, startDate, endDate, price) => {
  let result = (
    differenceInSeconds(endDate, currentDate) / differenceInSeconds(endDate, startDate)
  ) * price;
  result = Math.max(result, 0);
  result = Math.round(result * 100) / 100;
  return result;
};

export const findPlanByDeviceType = (plans, deviceType) => (
  plans.find((plan) => plan.device_type === deviceType)
);

/**
  *  Looking for same plan with different interval
  *  @param {Plan} selectedPlans
  *  @param {Plan[]} allPlans - all available plans
  *  @returns {Plan}
  */
const RE_MONTH_INTERVAL = new RegExp(`${PLAN_CODE_INTERNVAL.MONTHLY}$`);
const RE_ANNUAL_INTERVAL = new RegExp(`${PLAN_CODE_INTERNVAL.ANNUAL}$`);
export const findOtherIntervalPlan = (selectedPlan, allPlans) => {
  const planCode = selectedPlan.plan_code;

  let differentInternval;

  if (planCode.endsWith(PLAN_CODE_INTERNVAL.MONTHLY)) {
    differentInternval = planCode.replace(RE_MONTH_INTERVAL, PLAN_CODE_INTERNVAL.ANNUAL);
  } else if (planCode.endsWith(PLAN_CODE_INTERNVAL.ANNUAL)) {
    differentInternval = planCode.replace(RE_ANNUAL_INTERVAL, PLAN_CODE_INTERNVAL.MONTHLY);
  } else {
    throw Error(`Couldn't find other interval for ${selectedPlan} plan`);
  }

  return allPlans.find((plan) => plan.plan_code === differentInternval);
};

/**
 * Calculate total plan price, i.e. base plan price and its add-ons.
 * @param {Plan} plan
 * @param {Number} quantity
 * @returns {Number}
 */

export const calculatePlanPrice = (plan, quantity) => {
  let { price } = plan;
  const addOn = plan.add_ons?.[0];
  if (addOn) {
    price += addOn.calculatePrice(quantity);
  }
  return price;
};

/**
  * Calculate cost difference between paying
  * for annual plan and paying monthly rate for 12 months
  * @param {Plan} plan
  * @param {Plan} reverseIntervalPlan - same as plan but with reversed interval
  * @param {Number} quantity - amount of concurrencies to calculate cost
  * @returns {Number}
  */
export const calculateSavings = (plan, quantity, reverseIntervalPlan) => {
  const planCost = calculatePlanPrice(plan, quantity);
  const otherIntervalPlanCost = calculatePlanPrice(reverseIntervalPlan, quantity);
  const isPlanAnnual = plan.interval_unit === PLAN_INTERVAL.YEAR;
  const monthlyPrice = isPlanAnnual ? otherIntervalPlanCost : planCost;
  const annualPrice = !isPlanAnnual ? otherIntervalPlanCost : planCost;

  return 12 * monthlyPrice - annualPrice;
};

/**
 * From given array, returns value that is closed to given value.
 * @param {number} value
 * @param {number[]} collection
 * @returns {number}
 */
export const findClosest = (value, collection) => {
  const allowedValuesByDistanceToValue = [...collection];
  allowedValuesByDistanceToValue.sort(
    (left, right) => Math.abs(left - value) - Math.abs(right - value),
  );
  return allowedValuesByDistanceToValue[0];
};
